/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircuitCell = createReactComponent("outline", "circuit-cell", "IconCircuitCell", [["path", { "d": "M2 12h8", "key": "svg-0" }], ["path", { "d": "M14 12h8", "key": "svg-1" }], ["path", { "d": "M10 5v14", "key": "svg-2" }], ["path", { "d": "M14 9v6", "key": "svg-3" }]]);

export { IconCircuitCell as default };
//# sourceMappingURL=IconCircuitCell.mjs.map
